import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

interface Option {
  value: string;
  label: string;
}

interface SelectSearchBoxProps {
  label?: string;
  options: Option[];
  selectedValue: string;
  placeholder?: string;
  onChange: (selectedValue: string) => void;
}

const SelectSearchBox: React.FC<SelectSearchBoxProps> = ({ 
  label,
  options,
  selectedValue,
  placeholder = '',
  onChange
}) => {
  console.log('-----------    select  search box   re-render    -----', label, selectedValue);
  const { i18n } = useTranslation();

  return (
    <div className='inline-block'>
      {label && (
        <label htmlFor="selectInput">
            {label}:&nbsp;
        </label>
      )}
        <select
            value={selectedValue}
            onChange={(e) => onChange(e.target.value)}
            className={`light-border p-2 rounded mr-[10px] ${i18n.language === 'jp' ? "w-[120px]" : "w-[200px]"} bg-white`}
            style={{
            border: "1px solid #ddd"
            }}
        >
            {placeholder && (
            <option value="" disabled>
                {placeholder}
            </option>
            )}
            {options.map((option) => (
            <option key={option.value} value={option.value}>
                {option.label}
            </option>
            ))}
        </select>
    </div>
  );
};

export default memo(SelectSearchBox);